import React from 'react'
import playstoreIcon from '../../../images/google-play-colored.svg';
import appstoreIcon from '../../../images/appstore-colored.svg';
import starBlack from '../../../images/star-black.svg';
import starWhite from '../../../images/star-white.svg';

// Shared by the ID pages (app-download modal, grow banner, welcome-rewards) AND the global/EN
// home, which are two different apps with two different store listings. The defaults below are
// the INDONESIA app's numbers, so every existing ID caller keeps its current output; the EN home
// passes the global app's figures explicitly.
const AppsPerformance = ({
    color = 'black',
    // SEOENG-138: read live 2 Oct 2026 (iTunes lookup id1603395383 country=id: 4.72 on 4,739;
    // Play io.tr8.gotradeindo.android country=id: 4.76 on 18,685). Rounded down on counts.
    appStoreRating = '4.7',
    appStoreReviews = '4.7K',
    playStoreRating = '4.8',
    playStoreReviews = '18K',
}) => {
    const textClass = color === 'white' ? 'text-white' : 'text-black';
    const starIcon = color === 'white' ? starWhite : starBlack;

    return (
        <div>
            <div className={`flex flex-col md:flex-row justify-center gap-2 md:gap-10 mt-2 ${textClass}`}>
                <div className='flex justify-center gap-2 items-center'>
                    <img src={appstoreIcon} alt='appstore' className='w-[32px]' />
                    <span className='text-sm'>
                        {appStoreRating}
                    </span>
                    <img src={starIcon} alt='star' className='w-[16px] md:w-[20px]' />
                    <span className='text-sm'>App Store {appStoreReviews} reviews</span>
                </div>
                <div className='flex justify-center gap-2 items-center'>
                    <img src={playstoreIcon} alt='playstore' className='w-[32px]' />
                    <span className='text-sm'>
                        {playStoreRating}
                    </span>
                    <img src={starIcon} alt='star' className='w-[16px] md:w-[20px]' />
                    <span className='text-sm'>Google Play {playStoreReviews} reviews</span>
                </div>
            </div>
        </div>
    )
}

export default AppsPerformance;